import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { Observable, of, forkJoin } from 'rxjs';
import { map, share, switchMap, tap } from 'rxjs/operators';
import { ItemsPerPageComponent } from '../../components/itemsPerPage.component';
import { I18nTranslator } from '../../i18n/translate';
import { ARBleCampaign, ARBleParcel } from '../../models/agrorendement-ble.model';
import { ARColzaCampaign, ARColzaParcel } from '../../models/agrorendement-colza.model';
import { AROrgeCampaign, AROrgeParcel } from '../../models/agrorendement-orge.model';
import { Campaign } from '../../models/campaign.model';
import { Farm } from '../../models/farm.model';
import { ListItem, Specy, Variety } from '../../models/lists.model';
import { Organisation } from '../../models/organisation.model';
import { Parcel } from '../../models/parcel.model';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { ExtractAttributePipe } from '../../pipes/extractAttribute.pipe';
import { HectareConverterPipe } from '../../pipes/hectareConverter.pipe';
import { ToLabelPipe } from '../../pipes/toLabel.pipe';
import { TranslateDatePipe, TranslatePipe } from '../../pipes/translate.pipe';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { ARCommonListsService } from '../../services/agrorendement-common-lists.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { FarmService } from '../../services/farm.service';
import { FarmerAuthorizationsService } from '../../services/farmer-authorizations.service';
import { isFarmerActionForbidden } from '../../utils/farmer-action-error';
import { KeycloakService } from '../../services/keycloak.service';
import { ListType, ListsService } from '../../services/lists.service';
import { OrganisationService } from '../../services/organisation.service';
import { PlanningFilterExploitation, PlanningFilterParcel, PlanningService } from '../../services/planning.service';
import { showErrorMessage, toNull, toNumber } from '../../utils/utils';
import { DatepickerDialogContext, PlanningDatePickerDialogComponent } from './planning-datepicker-dialog.component';
import { CustomStatusModalComponent, StatusModalContext } from './custom-status-modal.component';
import { canSuspendParcelFunc, canReactivateParcelFunc } from './planning-parcel.rules';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'planning-parcel',
  styleUrls: ['planning-parcel.component.scss'],
  templateUrl: './planning-parcel.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    ItemsPerPageComponent,
    CapitalizePipe,
    ExtractAttributePipe,
    ToLabelPipe,
    TranslateDatePipe,
    HectareConverterPipe,
    TranslatePipe,
    CommonModule,
    FormsModule,
    PaginationModule,
  ],
  providers: [
    ARCommonListsService,
    PlanningService,
    FarmService,
    ARColzaService,
    ARBleService,
    AROrgeService,
    OrganisationService,
    TranslateDatePipe,
  ],
})
export class PlanningSelectParcel implements OnInit, AfterViewInit {
  @Input()
  culture: string;

  @Input()
  passage: string;

  @Input()
  farms: Array<Farm>;

  @Input()
  parcels: Array<Parcel>;

  @Input('parcelIds')
  checkedParcelIds: Set<number>;

  @Input('parcelIdMapping')
  parcelIdsNames: Map<number, string>;

  @ViewChild('checkboxAll') checkboxAll: any;

  @Output()
  modifier = new EventEmitter<Parcel>();

  @Output()
  modifierSelection = new EventEmitter();

  static filterToApply: PlanningFilterParcel;
  dt: string;
  farmParcelIndex = new Map<number, Array<Parcel>>();

  public sortColumn: string = '';
  public sortOrder: 'asc' | 'desc' = 'asc';

  static filterFarmToApply: PlanningFilterExploitation;

  public rows: Array<any> = [];
  public farmIds: number[] = [];
  editingParcelId: number = null;
  date: Date = null;
  dateStr: string = null;
  dateChanged: boolean = false;
  hasUnsavedChanges: boolean = false;

  public showModifyPopup: boolean = false;
  public planningDateError: boolean = false;
  public organisationFilter: number = null;
  public organisations: Organisation[];
  public filterPostal: string = '';
  public prefixParcel: string = '';
  public prefixExploitation: string = '';
  public prefixAdvisor: string = '';
  public prefixFilterIdParcel: number = null;
  public dateAvant: string = null;
  public dateApres: string = null;
  public datePlanningAfter: string = null;
  public datePlanningBefore: string = null;
  public filter: string = '';

  public specyFilter: number | string = null;
  public varietyFilter: number | string = null;
  public personalizedDateFilter: number | string = null;
  public suspendedFilter: boolean = null;
  public campaignFilter: number;
  public campaignYear: number;
  public filterConseiller: string = '';

  public keepFarm: Array<Farm> = [];

  speciesDict: Map<number, Specy>;
  species: Specy[];
  showSpeciesFilter: Specy[] = [];
  showVarietyFilter: Variety[] = [];

  colzaCulture: boolean = false;
  public isAdmin: boolean;
  public isNegoce: boolean;

  public allParcelIds: any[] = [];
  public allParcelList: Parcel[] = [];

  public fullParcel: Observable<any>;
  public lastGet: Set<number> = new Set<number>();
  public page: number = 1;
  public maxSize: number = 5;
  public itemsPerPage: number = 25;
  public totalPages: number = 1;
  public length: number = 0;

  public lengthAllParcels: number;
  paginatedParcels: any[] = [];

  selectedParcels: Parcel[] = [];
  selectedParcelIds: any[] = [];

  campaignsOrge: AROrgeCampaign[];
  campaignsBle: ARBleCampaign[];
  campaignsColza: ARColzaCampaign[];

  weekNumberFilter: number;
  dateFilter: string;
  weekNumberFromQueryParam: number;
  dateFromQueryParam: any;
  cultureLabel: string;

  emptyFilter: PlanningFilterParcel = {
    prefixParcel: '',
    prefixIdParcel: null,
    dateAvant: '',
    dateApres: '',
    postalCode: '',
    prefixExploitation: '',
    prefixAdvisor: '',
    datePlanningAfter: '',
    datePlanningBefore: '',
    specy: null,
    variety: null,
    organisationId: null,
    personalizedDate: null,
    suspended: null,
  };

  // Loaded async from block 6 (C2027-196); defaults to true so controls do not flicker.
  canPlanDelivery = true;

  constructor(
    private planningService: PlanningService,
    private cd: ChangeDetectorRef,
    private organisationService: OrganisationService,
    private colzaService: ARColzaService,
    private bleService: ARBleService,
    private orgeService: AROrgeService,
    private listsService: ListsService,
    private i18nTranslator: I18nTranslator,
    public datepipe: TranslateDatePipe,
    private router: Router,
    private modal: ModalService,
    private farmerAuthorizationsService: FarmerAuthorizationsService,
  ) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.isNegoce = KeycloakService.auth.authz.hasRealmRole('ROLE_NEGOCE');
    this.farmerAuthorizationsService.can('planDelivery').subscribe((allowed) => (this.canPlanDelivery = allowed));
  }

  ngOnInit() {
    const queryParams = this.getQueryParamsFromUrl();
    const culture = queryParams['culture'];
    const passage = queryParams['passage'];
    const weekNumber = queryParams['weekNumber'];
    const dateFrom = queryParams['date'];
    const dateAvant = queryParams['dateAvant'];
    const dateApres = queryParams['dateApres'];
    const personalizedDate = queryParams['personalizedDate'];

    if (culture) {
      this.culture = queryParams['culture'];
    }

    if (this.culture) {
      this.cultureLabel = this.i18nTranslator.translate('planning.culture.' + this.culture);
    }

    if (passage) {
      this.passage = passage;
    }

    if (weekNumber) {
      this.datePlanningAfter = dateApres;
      this.datePlanningBefore = dateAvant;
    } else {
      this.datePlanningAfter = dateFrom;
      this.datePlanningBefore = dateFrom;
    }

    this.prefixExploitation = queryParams['prefixExploitation'];
    this.organisationFilter = toNumber(queryParams['organisationId']);
    this.prefixAdvisor = queryParams['prefixAdvisor'];
    this.personalizedDateFilter = personalizedDate ? personalizedDate : null;

    PlanningSelectParcel.filterToApply = {
      prefixParcel: null,
      prefixIdParcel: null,
      dateAvant: null,
      dateApres: null,
      postalCode: null,
      prefixExploitation: toNull(this.prefixExploitation),
      prefixAdvisor: toNull(this.prefixAdvisor),
      datePlanningAfter: toNull(this.datePlanningAfter),
      datePlanningBefore: toNull(this.datePlanningBefore),
      specy: null,
      variety: null,
      organisationId: toNumber(this.organisationFilter),
      personalizedDate: toNull(this.personalizedDateFilter),
      suspended: null,
    };

    /*
     *Farm logic
     */

    const obs1 = this.getBleCampaigns();
    const obs2 = this.getOrgeCampaigns();
    const obs3 = this.getColzaCampaigns();
    const obs4 = this.getOrganisations();
    const obs5 = this.getSpecies();

    if (this.culture === 'colza') {
      this.colzaCulture = true;
    }

    forkJoin([obs1, obs2, obs3, obs4, obs5]).subscribe((data: Array<any>) => {
      let temp: any;
      if (this.culture === 'ble') {
        temp = data[0];
        const endingOnStr: string = temp[0].endingOn;
        const endingOnDate: Date = new Date(endingOnStr);
        this.campaignYear = endingOnDate.getUTCFullYear();
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'orge') {
        temp = data[1];
        const endingOnStr: string = temp[0].endingOn;
        const endingOnDate: Date = new Date(endingOnStr);
        this.campaignYear = endingOnDate.getUTCFullYear();
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'colza') {
        temp = data[2];
        const endingOnStr: string = temp[0].endingOn;
        const endingOnDate: Date = new Date(endingOnStr);
        this.campaignYear = endingOnDate.getUTCFullYear();
        this.campaignFilter = temp[0].id;
      }
      this.campaignFilter;
      this.updateUIWithFilters();
      this.onChangeTable();
    });
  }
  ngAfterViewInit() {}

  getQueryParamsFromUrl(): any {
    const queryParams: any = {};
    const search = window.location.search.substring(1);
    if (search) {
      const pairs = search.split('&');
      for (const pair of pairs) {
        const [key, value] = pair.split('=');
        queryParams[decodeURIComponent(key)] = decodeURIComponent(value || '');
      }
    }
    return queryParams;
  }

  getParcels(sortColumnName: string, sortColumnOrder: string, filter: PlanningFilterParcel) {
    this.planningService
      .getParcelsFarms(
        this.culture,
        this.passage,
        this.campaignFilter,
        this.farmIds,
        sortColumnName,
        sortColumnOrder,
        null,
        filter,
        true,
        this.page - 1,
        this.itemsPerPage,
      )
      .subscribe(
        (response: any) => {
          this.handleList(response);
          this.totalPages = response.data.totalPages;
          this.lengthAllParcels = response.data.totalElements;
        },
        (error) => {
          this.handleError(error);
        },
      );
  }

  handleListFarm(sortColumnName: string, sortColumnOrder: string, filter: PlanningFilterExploitation) {
    this.planningService
      .getFarms(this.culture, this.passage, this.campaignFilter, null, sortColumnName, sortColumnOrder, filter, null)
      .subscribe(
        (result: any) => {
          this.farmIds = result;
          this.getParcels(this.sortColumn, this.sortOrder, PlanningSelectParcel.filterToApply);
        },
        (e) => {
          this.handleError(e);
        },
      );
  }

  handleError(e: any) {
    if (e.status == 400) {
      this.modal
        .alert(this.i18nTranslator.translate('planning.parcelles.error.noParcelles'))
        .then(() => this.router.navigate(['/planning']));
    } else {
      this.modal.alert(this.i18nTranslator.translate('planning.parcelles.error.parcelles.2'));
    }
  }

  private handleList(response: any): void {
    this.farms = [];
    this.allParcelList = [];
    this.farmParcelIndex = new Map<number, Parcel[]>();
    this.showVarietyFilter = [];
    this.showSpeciesFilter = [];

    const list = response.data.content;
    this.lengthAllParcels = response.data.totalElements;
    this.totalPages = response.data.totalPages;
    this.paginatedParcels = list;

    if (list.length === 0) {
      this.fullParcel = of([]);
      return;
    }

    const requests = list.map((item) => this.planningService.getParcel(item.id, this.culture));

    this.fullParcel = forkJoin(requests).pipe(
      map((parcels: any[]) => {
        parcels.forEach((parcel) => {
          parcel.isEditing = false;
          parcel.newSuspended = this.getSuspendedState(parcel);
          parcel.suspended = parcel.newSuspended;
          this.lastGet.add(parcel.id);

          this.allParcelList.push(parcel);

          if (this.culture === 'colza') {
            if (!this.showVarietyFilter.some((v) => v.code === parcel.variety.code)) {
              this.showVarietyFilter.push(parcel.variety);
            }
          } else {
            if (!this.showSpeciesFilter.some((s) => s.code === parcel.specy.code)) {
              this.showSpeciesFilter.push(parcel.specy);
            }
          }

          const farmId = parcel.farm.id;
          const group = this.farmParcelIndex.get(farmId) || [];
          group.push(parcel);
          group.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
          this.farmParcelIndex.set(farmId, group);
        });

        if (this.checkedParcelIds && this.checkedParcelIds.size > 0) {
          this.checkedParcelIds.forEach((id) => {
            if (!list.some((p) => p.id === id)) {
              this.parcelIdsNames.delete(id);
              this.checkedParcelIds.delete(id);
            }
          });
        }

        return parcels;
      }),
    );
  }

  getAllParcelIds(): Observable<number[]> {
    return new Observable((subscriber: any) => {
      this.planningService
        .getAllParcelsFarms(
          this.culture,
          this.passage,
          this.campaignFilter,
          this.farmIds,
          null,
          null,
          null,
          PlanningSelectParcel.filterToApply,
          true,
        )
        .subscribe(
          (response: any) => {
            if (Array.isArray(response.data)) {
              this.allParcelIds = response.data.map((parcel) => parcel.id);
            }

            subscriber.next(this.allParcelIds);
            subscriber.complete();
          },
          (error) => {
            this.handleError(error);
            subscriber.error(error);
          },
        );
    });
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    this.page = page.page;
    this.itemsPerPage = page.itemsPerPage;
    this.handleListFarm(this.sortColumn, this.sortOrder, PlanningSelectParcel.filterFarmToApply);
  }

  onSort(column: string): void {
    let realField = column;

    if (column === 'dateLivraison') {
      realField = this.getDateLivraisonField();
    } else if (column === 'week') {
      realField = this.getWeekField();
    }

    if (this.sortColumn === realField) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = realField;
      this.sortOrder = 'asc';
    }

    this.page = 1;
    this.onChangeTable({ page: this.page, itemsPerPage: this.itemsPerPage });
  }

  private getWeekField(): string {
    if (this.culture === 'colza') {
      return 'week';
    }
    if (this.culture === 'ble') {
      const mapBleWeek: { [p: string]: string } = {
        BLET1: 'defaultWeekT1',
        BLET2: 'defaultWeekT2',
        BLET3: 'defaultWeekT3',
        BLEDN: 'defaultWeekDn',
      };
      return mapBleWeek[this.passage] || '';
    }
    if (this.culture === 'orge') {
      const mapOrgeWeek: { [p: string]: string } = {
        ORGET1: 'defaultWeekT1',
        ORGET2: 'defaultWeekT2',
        ORGET3: 'defaultWeekT3',
      };
      return mapOrgeWeek[this.passage] || '';
    }
    return '';
  }

  private getDateLivraisonField(): string {
    if (this.culture === 'colza') {
      return this.passage === 'COLZAEH' ? 'eh_date_livraison' : 'sh_date_livraison';
    }
    if (this.culture === 'ble') {
      const mapBle: { [p: string]: string } = {
        BLET1: 't1_date_livraison',
        BLET2: 't2_date_livraison',
        BLET3: 't3_date_livraison',
        BLEDN: 'dn_date_livraison',
      };
      return mapBle[this.passage] || '';
    }
    if (this.culture === 'orge') {
      const mapOrge: { [p: string]: string } = {
        ORGET1: 't1_date_livraison',
        ORGET2: 't2_date_livraison',
        ORGET3: 't3_date_livraison',
      };
      return mapOrge[this.passage] || '';
    }
    return '';
  }

  public isWeekSorted(): boolean {
    return this.sortColumn === this.getWeekField();
  }

  public isDateLivraisonSorted(): boolean {
    return this.sortColumn === this.getDateLivraisonField();
  }

  onItemsPerPageChange(newPageSize: number) {
    this.itemsPerPage = newPageSize;
    this.page = 1;
    this.getParcels(null, null, PlanningSelectParcel.filterToApply);
    this.cd.detectChanges();
  }

  handleErroWithMsg(error: any, msg: string) {
    if (typeof error === 'string') {
      showErrorMessage(this.modal, msg);
      return;
    }

    if (isFarmerActionForbidden(error)) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('error.farmerActionForbidden'));
    } else if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('planning.error.unauthorized'));
    } else {
      console.error(error);

      let errorMessage = msg;

      try {
        const errorBody = JSON.parse(error._body);

        if (errorBody && errorBody.errorMessage) {
          errorMessage = errorBody.errorMessage;
        }
      } catch (e) {
        console.warn('Error parsing error:', e);
      }
      showErrorMessage(this.modal, errorMessage);
    }
  }

  formatDateForInput(dateStr: string): string {
    // Convert dateStr to 'YYYY-MM-DD' format required by <input type="date">
    if (!dateStr) {
      return null;
    }
    return dateStr.slice(0, 10);
  }

  startEditing(parcel: any): void {
    this.editingParcelId = parcel.id;
    parcel.isEditing = true;
  }

  cancelChanges(parcel: any): void {
    if (parcel.dateChanged) {
      parcel.newDate = null;
      parcel.dateChanged = false;
    }
    if (parcel.suspendedChanged) {
      if (parcel.orderItem && parcel.orderItem.suspended !== undefined && parcel.orderItem.suspended !== null) {
        parcel.newSuspended = parcel.orderItem.suspended;
      } else {
        parcel.newSuspended = false;
      }
      parcel.suspendedChanged = false;
    }
    this.hasUnsavedChanges = false;
    this.editingParcelId = null;
    this.dateStr = null;
    parcel.isEditing = false;
  }

  onDateChange(parcel: any): void {
    parcel.newDate = this.dateStr;
    parcel.dateChanged = true;
    this.hasUnsavedChanges = true;
  }

  validatePlanningDateRange(): void {
    if (this.datePlanningBefore && this.datePlanningAfter) {
      // Crear fechas en UTC sin ajuste de zona horaria
      const beforeDate = new Date(
        Date.UTC(
          Number(this.datePlanningBefore.substring(0, 4)), // Año
          Number(this.datePlanningBefore.substring(5, 7)) - 1, // Mes (0-indexed)
          Number(this.datePlanningBefore.substring(8, 10)), // Día
        ),
      );

      const afterDate = new Date(
        Date.UTC(
          Number(this.datePlanningAfter.substring(0, 4)),
          Number(this.datePlanningAfter.substring(5, 7)) - 1,
          Number(this.datePlanningAfter.substring(8, 10)),
        ),
      );

      // Comparar fechas
      this.planningDateError = beforeDate < afterDate;

      if (this.planningDateError) {
        showErrorMessage(this.modal, this.i18nTranslator.translate('planning.error.date.range'));
      }
    }
  }

  canModify(parcel: any): boolean {
    return parcel.dateChanged === true || parcel.suspendedChanged === true;
  }

  saveChanges(parcel: any): void {
    let parcelToChange: any;
    let getOrderItem$: Observable<any>;
    let saveOrderItem$: (orderItem: any) => Observable<any>;

    if (this.culture === 'ble') {
      parcelToChange = parcel as ARBleParcel;
      getOrderItem$ = this.bleService.getOrderItem(parcelToChange.orderItem.id);
      saveOrderItem$ = (orderItem) => this.bleService.saveOrderItem(orderItem);
    } else if (this.culture === 'orge') {
      parcelToChange = parcel as AROrgeParcel;
      getOrderItem$ = this.orgeService.getOrderItem(parcelToChange.orderItem.id);
      saveOrderItem$ = (orderItem) => this.orgeService.saveOrderItem(orderItem);
    } else if (this.culture === 'colza') {
      parcelToChange = parcel as ARColzaParcel;
      getOrderItem$ = this.colzaService.getOrderItem(parcelToChange.orderItem.id);
      saveOrderItem$ = (orderItem) => this.colzaService.saveOrderItem(orderItem);
    } else {
      console.error('Cultura not supported:', this.culture);
      return;
    }

    getOrderItem$
      .pipe(
        switchMap((orderItem) => {
          this.updateOrderItem(orderItem, parcel);
          return saveOrderItem$(orderItem);
        }),
      )
      .subscribe(
        (response) => {
          this.resetParcelChanges(parcel);
          this.applyFilters();
        },
        (error) => {
          this.handleErroWithMsg(error, this.i18nTranslator.translate('planning.error.update'));
        },
      );
  }

  private resetParcelChanges(parcel: any): void {
    parcel.dateChanged = false;
    parcel.newDate = null;
    parcel.suspendedChanged = false;
    this.hasUnsavedChanges = false;
    this.editingParcelId = null;
    parcel.isEditing = false;
  }

  private updateOrderItem(orderItem: any, parcel: any): void {
    if (parcel.suspendedChanged) {
      const suspended = parcel.suspended;

      if (this.culture === 'colza') {
        switch (this.passage) {
          case 'COLZAEH':
            orderItem.suspended = suspended;
            break;
          case 'COLZASH':
            orderItem.suspended = suspended;
            break;
        }
      } else if (this.culture === 'ble') {
        switch (this.passage) {
          case 'BLET1':
            orderItem.suspendedT1 = suspended;
            break;
          case 'BLET2':
            orderItem.suspendedT2 = suspended;
            break;
          case 'BLEDN':
            orderItem.suspendedDn = suspended;
            break;
          case 'BLET3':
            orderItem.suspendedT3 = suspended;
            break;
        }
      } else if (this.culture === 'orge') {
        switch (this.passage) {
          case 'ORGET1':
            orderItem.suspendedT1 = suspended;
            break;
          case 'ORGET2':
            orderItem.suspendedT2 = suspended;
            break;
          case 'ORGET3':
            orderItem.suspendedT3 = suspended;
            break;
        }
      }
    }

    if (parcel.dateChanged) {
      const dateToSave = new Date(parcel.newDate);
      if (!isNaN(dateToSave.getTime())) {
        dateToSave.setHours(2);
      } else {
        console.error('invalid date:', parcel.newDate);
        return;
      }
      if (this.culture === 'colza') {
        switch (this.passage) {
          case 'COLZAEH':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.eh_date_livraison = dateToSave;
            }
            break;
          case 'COLZASH':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.sh_date_livraison = dateToSave;
            }
            break;
        }
      } else if (this.culture === 'ble') {
        switch (this.passage) {
          case 'BLET1':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t1_date_livraison = dateToSave;
            }
            break;
          case 'BLET2':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t2_date_livraison = dateToSave;
            }
            break;
          case 'BLEDN':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.dn_date_livraison = dateToSave;
            }
            break;
          case 'BLET3':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t3_date_livraison = dateToSave;
            }
            break;
        }
      } else if (this.culture === 'orge') {
        switch (this.passage) {
          case 'ORGET1':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t1_date_livraison = dateToSave;
            }
            break;
          case 'ORGET2':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t2_date_livraison = dateToSave;
            }
            break;
          case 'ORGET3':
            if (this.notInPastOrderItem(dateToSave) && this.notToday(dateToSave) && this.notTomorrow(dateToSave)) {
              orderItem.t3_date_livraison = dateToSave;
            }
            break;
        }
      }
    }
  }

  notInPastOrderItem(dateOrderItem: any) {
    if (dateOrderItem && !this.isAdmin) {
      const date = new Date(dateOrderItem);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = date.getTime() - now.getTime();
      return time > 0;
    }

    return true;
  }

  clearFilters() {
    this.resetFilter();
    this.applyFilters();
  }

  resetFilter() {
    this.filter = null;
    this.filterPostal = null;
    this.prefixExploitation = null;
    this.prefixAdvisor = null;
    this.prefixParcel = null;
    this.dateApres = null;
    this.dateAvant = null;
    this.datePlanningAfter = null;
    this.datePlanningBefore = null;
    this.prefixFilterIdParcel = null;

    if (this.colzaCulture) {
      this.varietyFilter = null;
    }
    if (!this.colzaCulture) {
      this.specyFilter = null;
    }

    this.organisationFilter = null;
    this.personalizedDateFilter = null;
    this.suspendedFilter = null;
  }
  updateUIWithFilters() {
    if (PlanningSelectParcel.filterToApply) {
      this.filterPostal = PlanningSelectParcel.filterToApply.postalCode;
      this.prefixExploitation = PlanningSelectParcel.filterToApply.prefixExploitation;
      this.prefixAdvisor = PlanningSelectParcel.filterToApply.prefixAdvisor;
      this.prefixParcel = PlanningSelectParcel.filterToApply.prefixParcel;
      this.prefixFilterIdParcel = PlanningSelectParcel.filterToApply.prefixIdParcel;
      this.dateAvant = PlanningSelectParcel.filterToApply.dateAvant;
      this.dateApres = PlanningSelectParcel.filterToApply.dateApres;
      if (this.colzaCulture) {
        this.varietyFilter = PlanningSelectParcel.filterToApply.variety;
      }
      if (!this.colzaCulture) {
        this.specyFilter = PlanningSelectParcel.filterToApply.specy;
      }

      this.organisationFilter = toNumber(PlanningSelectParcel.filterToApply.organisationId);

      this.personalizedDateFilter = PlanningSelectParcel.filterToApply.personalizedDate;
    }
  }

  applyFilters() {
    this.validatePlanningDateRange();
    if (this.planningDateError) {
      console.error("Date validation failed: 'Planning Before' cannot be after 'Planning After'");
      this.planningDateError = false;
      return; // Stop the filter application if there's an error
    }
    this.resetFilterToApply();
    this.page = 1;
    this.onChangeTable();
  }

  resetFilterToApply() {
    PlanningSelectParcel.filterToApply = {
      prefixParcel: this.prefixParcel,
      prefixIdParcel: toNumber(this.prefixFilterIdParcel),
      dateAvant: this.dateAvant,
      dateApres: this.dateApres,
      postalCode: this.filterPostal,
      prefixExploitation: this.prefixExploitation,
      prefixAdvisor: this.prefixAdvisor,
      datePlanningAfter: this.datePlanningAfter,
      datePlanningBefore: this.datePlanningBefore,
      specy: this.specyFilter,
      variety: this.varietyFilter,
      organisationId: toNull(this.organisationFilter),
      personalizedDate: this.personalizedDateFilter,
      suspended: this.suspendedFilter,
    };
  }

  onCheckboxAllClicked(): void {
    if (this.checkboxAll.nativeElement.checked) {
      this.getAllParcelIds().subscribe((parcelIds) => {
        this.selectedParcelIds = parcelIds;
      });
    } else {
      this.clearCheckboxes();
    }
    this.cd.detectChanges();
  }

  isCheckboxAllChecked(): boolean {
    return this.allParcelIds.length > 0 && this.selectedParcelIds.length === this.allParcelIds.length;
  }

  isIndeterminate(): boolean {
    return this.selectedParcelIds.length > 0 && this.selectedParcelIds.length < this.allParcelIds.length;
  }

  clearCheckboxes(): void {
    this.selectedParcelIds = [];
    this.selectedParcels = [];
    this.allParcelIds = [];
    const selectedRows = Array.from(document.querySelectorAll('.row-selected'));
    selectedRows.forEach((row) => row.classList.remove('row-selected'));
    this.cd.detectChanges();
  }

  // Action on HMTL/CSS
  moreThan2000(dateString: string) {
    if (dateString) {
      return Number(dateString.split('-')[0]) > 2000;
    }
    return false;
  }

  isParcelChecked(parcel: Parcel): boolean {
    return this.selectedParcels.some((selectedParcel) => selectedParcel.id === parcel.id);
  }

  openMultiSuspendPopup(parcel: any, isSuspended: boolean, idList: number[]): void {
    const context = {
      title: this.i18nTranslator.translate('planning.multipleSelection.warning.title'),
      message: this.i18nTranslator.translate('planning.multipleSelection.warning.message'),
      confirmButtonText: this.i18nTranslator.translate('button.confirm'),
      cancelButtonText: this.i18nTranslator.translate('planning.button.back'),
      isBlocking: true,
    };

    this.modal.confirm(context.message).then((confirmed) => {
      if (confirmed) {
        this.updateSuspendStateForAll(isSuspended, idList);
        this.clearCheckboxes();
      } else {
        console.log('Suspend action was canceled by the user.');
        parcel.suspended = !isSuspended;
        this.cd.detectChanges();
      }
    });
  }

  getActiveRole() {
    const roles = ['ROLE_ADMIN', 'ROLE_SECTOR', 'ROLE_NEGOCE', 'ROLE_FARMER', 'ROLE_ADVISOR', 'ROLE_MANAGER'];
    return roles.find((role) => KeycloakService.auth.authz.hasRealmRole(role)) || null;
  }

  canSuspendParcel(parcel: any) {
    return canSuspendParcelFunc(this.getActiveRole(), parcel, this.culture, this.passage, this.campaignYear);
  }

  canReactivateParcel(parcel: any) {
    return canReactivateParcelFunc(this.getActiveRole(), parcel, this.culture, this.passage, this.campaignYear);
  }

  onSuspendedChange(parcel: any, isChecked: boolean): void {
    if (!this.canPlanDelivery) {
      return;
    }
    const idList = this.getSelectedList();

    // Handle multi-select case with a separate popup
    if (idList.length > 1) {
      this.openMultiSuspendPopup(parcel, isChecked, idList);
      return;
    }

    const title = this.i18nTranslator.translate('planning.message.Title');
    const checkFn = isChecked ? this.canSuspendParcel.bind(this) : this.canReactivateParcel.bind(this);
    const { allowed, messageKey, updatePDate } = checkFn(parcel);

    if (updatePDate && !isChecked) {
      const defaultRestitutionDate = this.calculateNextBusinessDay(3);
      parcel.dateChanged = true;
      parcel.newDate = defaultRestitutionDate;
    }

    const resultObj: { [key: string]: number } = {};
    resultObj[messageKey] = 1;

    if (!allowed) {
      this.showStatusParcelPopup(title, resultObj);
      setTimeout(() => {
        parcel.suspended = !isChecked;
        this.cd.detectChanges();
      });
      return;
    } else {
      this.showStatusParcelPopup(title, resultObj);
    }

    parcel.suspendedChanged = true;
    parcel.suspended = isChecked;
    this.saveChanges(parcel);
  }

  private calculateNextBusinessDay(businessDays: number): Date {
    const date = new Date();
    let daysAdded = 0;

    while (daysAdded < businessDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        // Exclude Saturdays (6) and Sundays (0)
        daysAdded++;
      }
    }

    return date;
  }

  private updateSuspendStateForAll(isSuspended: boolean, idList: number[]): void {
    if (!this.canPlanDelivery) {
      return;
    }
    const updateService = this.getUpdateService();
    if (!updateService) return;

    updateService.updateParcelsBatch(idList, null, this.passage, isSuspended).subscribe(
      (response: any) => {
        this.showStatusParcelPopup(this.i18nTranslator.translate('planning.batchUpdate.resultsTitle'), response.data);

        this.applyFilters();
      },
      (error) => {
        this.handleErroWithMsg(error, this.i18nTranslator.translate('planning.error.update'));
        this.applyFilters();
      },
    );
  }

  private getUpdateService(): any {
    if (this.culture === 'ble') {
      return this.bleService;
    } else if (this.culture === 'orge') {
      return this.orgeService;
    } else if (this.culture === 'colza') {
      return this.colzaService;
    } else {
      console.error('Culture not supported:', this.culture);
      return null;
    }
  }

  private showStatusParcelPopup(title: string, statusResults: { [messageKey: string]: number } = {}): void {
    const messages: { text: string; isError: boolean }[] = [];

    let successDateUpdates = 0;
    let failedDateUpdates = 0;

    Object.entries(statusResults).forEach(([key, count]) => {
      if (key === 'success_date_updates') {
        successDateUpdates = count;
      } else if (key === 'failed_date_updates') {
        failedDateUpdates = count;
      } else {
        const isError = key.includes('error') || key.includes('failed');

        if (count === 1) {
          key = key + '.singular';
        }

        if (!key.includes('planning')) {
          key = 'planning.' + key;
        }

        let reasonText = this.i18nTranslator.translate(key);
        if (reasonText.includes('{{count}}')) {
          reasonText = reasonText.replace('{{count}}', count.toString());
        }

        messages.push({ text: reasonText, isError });
      }
    });

    if (successDateUpdates > 0) {
      messages.push({
        text: `${successDateUpdates} ${this.i18nTranslator.translate('planning.success.dateUpdates')}`,
        isError: false,
      });
    }

    if (failedDateUpdates > 0) {
      messages.push({
        text: `${failedDateUpdates} ${this.i18nTranslator.translate('planning.error.failedDateUpdates')}`,
        isError: true,
      });
    }

    const context = new StatusModalContext();
    Object.assign(context, {
      title,
      messages,
      dialogClass: 'modal-dialog',
      size: 'lg',
      showClose: true,
      keyboard: true,
      blocking: false,
      closeByClickingOutside: false,
    });

    this.modal.open(CustomStatusModalComponent, context).then((result) => {
      // Modal closed
    });
  }

  getDateLabel(parcel: any): string {
    let dateStr;
    if (parcel.dateChanged) {
      dateStr = parcel.newDate;
    } else {
      dateStr = this.getDate(parcel);
    }
    if (dateStr) {
      return this.formatDateDisplay(dateStr);
    }
    return this.i18nTranslator.translate('planning.parcelles.aRenseigner');
  }

  formatDateDisplay(dateStr: any): string {
    if (dateStr instanceof Date) {
      dateStr = dateStr.toISOString().split('T')[0];
    }
    if (typeof dateStr === 'string' && dateStr.includes('T')) {
      dateStr = dateStr.split('T')[0];
    }
    if (typeof dateStr === 'string') {
      const [year, month, day] = dateStr.split('-').map(Number);

      // Manually pad with '0' if necessary
      const formattedDay = (day < 10 ? '0' : '') + day;
      const formattedMonth = (month < 10 ? '0' : '') + month;
      return `${formattedDay}/${formattedMonth}/${year}`;
    }
    return '';
  }

  getDate(parcel: any) {
    if (parcel.orderItem) {
      switch (this.culture) {
        case 'ble':
          switch (this.passage) {
            case 'BLET1':
              if (parcel.orderItem.t1_date_livraison) {
                return parcel.orderItem.t1_date_livraison;
              } else {
                return null;
              }
            case 'BLET2':
              if (parcel.orderItem.t2_date_livraison) {
                return parcel.orderItem.t2_date_livraison;
              } else {
                return null;
              }
            case 'BLEDN':
              if (parcel.orderItem.dn_date_livraison) {
                return parcel.orderItem.dn_date_livraison;
              } else {
                return null;
              }
            case 'BLET3':
              if (parcel.orderItem.t3_date_livraison) {
                return parcel.orderItem.t3_date_livraison;
              } else {
                return null;
              }
          }
          break;
        case 'orge':
          switch (this.passage) {
            case 'ORGET1':
              if (parcel.orderItem.t1_date_livraison) {
                return parcel.orderItem.t1_date_livraison;
              } else {
                return null;
              }
            case 'ORGET2':
              if (parcel.orderItem.t2_date_livraison) {
                return parcel.orderItem.t2_date_livraison;
              } else {
                return null;
              }
            case 'ORGET3':
              if (parcel.orderItem.t3_date_livraison) {
                return parcel.orderItem.t3_date_livraison;
              } else {
                return null;
              }
          }
          break;
        case 'colza':
          switch (this.passage) {
            case 'COLZASH':
              if (parcel.orderItem.sh_date_livraison) {
                return parcel.orderItem.sh_date_livraison;
              } else {
                return null;
              }
            case 'COLZAEH':
              if (parcel.orderItem.eh_date_livraison) {
                return parcel.orderItem.eh_date_livraison;
              } else {
                return null;
              }
          }
          break;
        default:
          return null;
      }
    } else {
      return null;
    }
  }

  isAdviceDelivered(parcel: any): boolean {
    if (!parcel || !parcel.results || !parcel.results.length) {
      return false;
    }

    // Match on the code rather than on a hard-coded id: the orge T1 result types are
    // inserted without an explicit id, so their ids differ between environments.
    let expectedResultTypeCode = '';

    switch (this.culture) {
      case 'ble':
        switch (this.passage) {
          case 'BLET1':
            expectedResultTypeCode = 'BLE_T1_REPORT';
            break;
          case 'BLET2':
            expectedResultTypeCode = 'BLE_T2_REPORT';
            break;
          case 'BLEDN':
            expectedResultTypeCode = 'BLE_DN_REPORT';
            break;
          case 'BLET3':
            expectedResultTypeCode = 'BLE_T3_REPORT';
            break;
        }
        break;

      case 'orge':
        switch (this.passage) {
          case 'ORGET1':
            expectedResultTypeCode = 'ORGE_T1_REPORT';
            break;
          case 'ORGET2':
            expectedResultTypeCode = 'ORGE_T2_REPORT';
            break;
          case 'ORGET3':
            expectedResultTypeCode = 'ORGE_T3_REPORT';
            break;
        }
        break;

      case 'colza':
        switch (this.passage) {
          case 'COLZASH':
            expectedResultTypeCode = 'COLZA_SH_REPORT';
            break;
        }
        break;

      default:
        console.warn('culture or passage nor defined:', this.culture, this.passage);
        return false;
    }

    const result = parcel.results.find(
      (res: any) => res.resultType.code === expectedResultTypeCode && res.isValidated === true,
    );

    return !!result;
  }

  getSuspendedState(parcel: any) {
    if (parcel.orderItem) {
      switch (this.culture) {
        case 'ble':
          switch (this.passage) {
            case 'BLET1':
              return parcel.orderItem.suspendedT1 !== undefined ? parcel.orderItem.suspendedT1 : null;
            case 'BLET2':
              return parcel.orderItem.suspendedT2 !== undefined ? parcel.orderItem.suspendedT2 : null;
            case 'BLEDN':
              return parcel.orderItem.suspendedDn !== undefined ? parcel.orderItem.suspendedDn : null;
            case 'BLET3':
              return parcel.orderItem.suspendedT3 !== undefined ? parcel.orderItem.suspendedT3 : null;
            default:
              return null;
          }
        case 'orge':
          switch (this.passage) {
            case 'ORGET1':
              return parcel.orderItem.suspendedT1 !== undefined ? parcel.orderItem.suspendedT1 : null;
            case 'ORGET2':
              return parcel.orderItem.suspendedT2 !== undefined ? parcel.orderItem.suspendedT2 : null;
            case 'ORGET3':
              return parcel.orderItem.suspendedT3 !== undefined ? parcel.orderItem.suspendedT3 : null;
            default:
              return null;
          }
        case 'colza':
          return parcel.orderItem.suspended !== undefined ? parcel.orderItem.suspended : null;
        default:
          return null;
      }
    } else {
      return null;
    }
  }

  getDefaultWeek(parcel: any): number {
    if (parcel.orderItem) {
      switch (this.culture) {
        case 'ble':
          switch (this.passage) {
            case 'BLET1':
              return parcel.orderItem.defaultWeekT1 && parcel.orderItem.defaultWeekT1.week
                ? parcel.orderItem.defaultWeekT1.week
                : 0;
            case 'BLET2':
              return parcel.orderItem.defaultWeekT2 && parcel.orderItem.defaultWeekT2.week
                ? parcel.orderItem.defaultWeekT2.week
                : 0;
            case 'BLEDN':
              return parcel.orderItem.defaultWeekDn && parcel.orderItem.defaultWeekDn.week
                ? parcel.orderItem.defaultWeekDn.week
                : 0;
            case 'BLET3':
              return parcel.orderItem.defaultWeekT3 && parcel.orderItem.defaultWeekT3.week
                ? parcel.orderItem.defaultWeekT3.week
                : 0;
          }
          break;
        case 'orge':
          switch (this.passage) {
            case 'ORGET1':
              return parcel.orderItem.defaultWeekT1 && parcel.orderItem.defaultWeekT1.week
                ? parcel.orderItem.defaultWeekT1.week
                : 0;
            case 'ORGET2':
              return parcel.orderItem.defaultWeekT2 && parcel.orderItem.defaultWeekT2.week
                ? parcel.orderItem.defaultWeekT2.week
                : 0;
            case 'ORGET3':
              return parcel.orderItem.defaultWeekT3 && parcel.orderItem.defaultWeekT3.week
                ? parcel.orderItem.defaultWeekT3.week
                : 0;
          }
          break;
        case 'colza':
          switch (this.passage) {
            case 'COLZASH':
              return parcel.orderItem.defaultWeek && parcel.orderItem.defaultWeek.week
                ? parcel.orderItem.defaultWeek.week
                : 0;
            case 'COLZAEH':
              return parcel.orderItem.defaultWeek && parcel.orderItem.defaultWeek.week
                ? parcel.orderItem.defaultWeek.week
                : 0;
          }
          break;
        default:
          return 0;
      }
    }
    return 0;
  }

  isOutsideCampaign(culture: string, passage: string, parcel: any): boolean {
    const personalizedDate = this.getDate(parcel);
    if (!personalizedDate) {
      throw new Error('A valid personalizedDate is required to validate the campaign.');
    }

    const targetDate = new Date(personalizedDate);
    targetDate.setHours(0, 0, 0, 0);

    let campaignStart: Date = null;
    let campaignEnd: Date = null;

    switch (culture.toLowerCase()) {
      case 'ble':
        switch (passage.toUpperCase()) {
          case 'BLET1':
            campaignStart = new Date(targetDate.getFullYear(), 0, 2); // January 2
            campaignEnd = new Date(targetDate.getFullYear(), 2, 31); // March 31
            break;
          case 'BLET2':
            campaignStart = new Date(targetDate.getFullYear(), 0, 2); // January 2
            campaignEnd = new Date(targetDate.getFullYear(), 5, 15); // June 15
            break;
          case 'BLEDN':
          case 'BLET3':
            campaignStart = new Date(targetDate.getFullYear(), 2, 14); // March 14
            campaignEnd = new Date(targetDate.getFullYear(), 5, 15); // June 15
            break;
        }
        break;

      case 'orge':
        switch (passage.toUpperCase()) {
          case 'ORGET1':
            campaignStart = new Date(targetDate.getFullYear(), 0, 2); // January 2
            campaignEnd = new Date(targetDate.getFullYear(), 2, 31); // March 31
            break;
          case 'ORGET2':
          case 'ORGET3':
            campaignStart = new Date(targetDate.getFullYear(), 0, 2); // January 2
            campaignEnd = new Date(targetDate.getFullYear(), 5, 15); // June 15
            break;
        }
        break;

      case 'colza':
        switch (passage.toUpperCase()) {
          case 'COLZASH':
          case 'COLZAEH':
            campaignStart = new Date(targetDate.getFullYear(), 1, 5); // February 5
            campaignEnd = new Date(targetDate.getFullYear(), 4, 15); // May 15
            break;
        }
        break;

      default:
        console.error(`Campaign is not configured for culture: ${culture} and passage: ${passage}`);
        return true;
    }

    if (!campaignStart || !campaignEnd) {
      console.error(`Campaign dates not found for culture: ${culture} and passage: ${passage}`);
      return true;
    }

    // Validate if the personalized date is outside the campaign range
    return targetDate < campaignStart || targetDate > campaignEnd;
  }

  notInPast(parcel: any) {
    if (this.isAdmin) {
      return true;
    }
    const temp: any = this.getDate(parcel);
    if (temp) {
      const date = new Date(temp);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = date.getTime() - now.getTime();
      return time >= 0;
    }
    return true;
  }

  notToday(parcel: any) {
    const temp: any = this.getDate(parcel);
    if (temp) {
      const date = new Date(temp);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      return !(
        now.getDate() === date.getDate() &&
        now.getMonth() === date.getMonth() &&
        date.getFullYear() === now.getFullYear()
      );
    }
    return true;
  }

  notTomorrow(parcel: any) {
    const temp: any = this.getDate(parcel);
    if (temp) {
      const date = new Date(temp);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      return !(
        now.getDate() + 1 === date.getDate() &&
        now.getMonth() === date.getMonth() &&
        date.getFullYear() === now.getFullYear()
      );
    }
    return true;
  }

  //Get Init
  getBleCampaigns(): Observable<ARBleCampaign[]> {
    const obs = this.bleService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsBle = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWithMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getColzaCampaigns(): Observable<ARColzaCampaign[]> {
    const obs = this.colzaService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsColza = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWithMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getOrgeCampaigns(): Observable<AROrgeCampaign[]> {
    const obs = this.orgeService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsOrge = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWithMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getOrganisations(): Observable<Organisation[]> {
    const obs = this.organisationService.getOrganisations().pipe(share());
    obs.subscribe({
      next: (orgs) => {
        const orga = orgs.sort((a, b) => a.name.localeCompare(b.name));
        this.organisations = orga;
      },
    });
    return obs;
  }

  getSpecies(): Observable<Map<ListType, ListItem[]>> {
    // TODO handle error
    // share => plusieurs subscribers sans plusieurs requetes
    const obs = this.listsService.getListTypes(ListType, ListType.SPECIES).pipe(share());
    obs.subscribe(
      (lists: Map<ListType, ListItem[]>) => {
        const species = lists.get(ListType.SPECIES);
        this.species = species.sort((a, b) => a.label.localeCompare(b.label));
        this.speciesDict = new Map<number, Specy>();

        for (const specy of species) {
          this.speciesDict.set(specy.id, specy);
        }
      },
      (err) => this.handleErroWithMsg(err, this.i18nTranslator.translate('planning.parcelles.error.cultures')),
    );

    return obs;
  }

  openWarningPopup(): void {
    if (!this.canPlanDelivery) {
      return;
    }
    const context = {
      title: this.i18nTranslator.translate('planning.multipleSelection.warning.title'),
      message: this.i18nTranslator.translate('planning.multipleSelection.warning.message'),
      confirmButtonText: this.i18nTranslator.translate('button.confirm'),
      cancelButtonText: this.i18nTranslator.translate('planning.button.back'),
      isBlocking: true,
    };

    this.modal.confirm(context.message).then((confirmed) => {
      if (confirmed) {
        this.openUpdateAllPopup();
      } else {
        console.log('The user close de warning message');
      }
    });
  }

  openUpdateAllPopup(): void {
    if (!this.canPlanDelivery) {
      return;
    }
    const context = new DatepickerDialogContext();
    context.showClose = true;
    context.isBlocking = true;
    context.size = 'lg';
    context.selectedParcels = this.selectedParcels;
    context.parent = this;
    context.isAdmin = this.isAdmin;
    context.culture = this.culture;
    context.passage = this.passage;
    context.campaignYear = this.campaignYear;

    this.modal.open(PlanningDatePickerDialogComponent, context).then((result) => {
      // Dialog closed
    });
  }

  openModifyPopup(parcel: any): void {
    if (!this.canPlanDelivery) {
      return;
    }
    if (this.isAdviceDelivered(parcel) && !this.isAdmin) {
      const reasonText = this.i18nTranslator.translate('planning.date.error.delivered');
      this.handleErroWithMsg('Parcel is already delivered', reasonText);
      return;
    }
    this.showModifyPopup = true;
    this.editingParcelId = parcel.id;

    const context = new DatepickerDialogContext();
    context.showClose = true;
    context.isBlocking = true;
    context.size = 'lg';
    context.parcel = parcel;
    context.parent = this;
    context.isAdmin = this.isAdmin;
    context.culture = this.culture;
    context.passage = this.passage;
    this.modal.open(PlanningDatePickerDialogComponent, context);
  }

  private getSelectedList(): any {
    const selectedParcelIds: number[] = this.selectedParcels.map((parcel) => parcel.id);

    let idList: number[] = [];

    if (this.allParcelIds.length > 1) {
      idList = Array.from(this.allParcelIds);
    } else if (selectedParcelIds.length > 1) {
      idList = Array.from(selectedParcelIds);
    }

    return idList;
  }

  onDateSelected(selectedDate: Date, parcel: any): void {
    if (!selectedDate) {
      return;
    }

    const idList = this.getSelectedList();

    if (idList.length > 1) {
      const updateService = this.getUpdateService();
      if (!updateService) return;

      if (!isNaN(selectedDate.getTime())) {
        selectedDate.setHours(2);

        updateService.updateParcelsBatch(idList, selectedDate, this.passage).subscribe(
          (response: any) => {
            let responseData: any = {};

            if (response && response.data) {
              responseData = response.data;
            }

            let success_date_updates = 0;
            let failed_date_updates = 0;

            if (responseData && typeof responseData === 'object') {
              if ('success_date_updates' in responseData) {
                success_date_updates = responseData.success_date_updates;
              }
              if ('failed_date_updates' in responseData) {
                failed_date_updates = responseData.failed_date_updates;
              }
            }

            this.showStatusParcelPopup(this.i18nTranslator.translate('planning.batchUpdate.resultsTitle'), {
              success_date_updates: success_date_updates,
              failed_date_updates: failed_date_updates,
            });

            this.applyFilters();
          },
          (error) => {
            this.handleErroWithMsg(error, this.i18nTranslator.translate('planning.error.update'));
          },
        );
      } else {
        console.error('invalid date:', selectedDate);
        return;
      }
    } else if (parcel) {
      parcel.newDate = selectedDate;
      parcel.dateChanged = true;
      this.saveChanges(parcel);
    }

    this.showModifyPopup = false;
    this.clearCheckboxes();
    this.cd.detectChanges();
  }

  toggleParcelSelection(parcelId: number, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const rowElement = document.querySelector(`#row-${parcelId}`) as HTMLElement;

    if (checked) {
      if (!this.selectedParcelIds.includes(parcelId)) {
        this.selectedParcelIds.push(parcelId);
        const parcel = this.allParcelList.find((p) => p.id === parcelId);
        if (parcel && !this.selectedParcels.some((p) => p.id === parcelId)) {
          this.selectedParcels.push(parcel);
        }
        rowElement.classList.add('row-selected');
      }
    } else {
      this.selectedParcelIds = this.selectedParcelIds.filter((id) => id !== parcelId);
      this.selectedParcels = this.selectedParcels.filter((p) => p.id !== parcelId);
      rowElement.classList.remove('row-selected');
    }
  }

  onBreadcrumbClick() {
    this.router.navigate(['/visualizer/calendar'], {
      queryParams: {
        reload: new Date().getTime(),
        culture: this.culture,
        passage: this.passage,
        campaign: this.campaignFilter,
      },
    });
  }
}
